module.exports = __webpack_public_path__ + "static/media/waitingConfirmation.2dbb97d3.png";